// frontend/admin-portal/src/services/rfqService.js
import api from './axiosConfig';

export const rfqService = {
    list: async (params = {}) => {
        const { data } = await api.get('/rfqs', { params });
        return data.data;
    },
    get: async (id) => {
        const { data } = await api.get(`/rfqs/${id}`);
        return data.data.rfq;
    },
    cancel: async (id) => {
        const { data } = await api.patch(`/rfqs/${id}/cancel`);
        return data.data.rfq;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/rfqs/${id}`);
        return data;
    },
    submitQuotation: async (rfqId, payload) => {
        const { data } = await api.post(`/rfqs/${rfqId}/quotation`, payload);
        return data.data.quotation;
    },

    // ---- CSV export/import ----
    exportTemplate: async (rfqId, rfqCode = 'rfq') => {
        const res = await api.get(`/rfqs/${rfqId}/export`, { responseType: 'blob' });
        const dispo = res.headers['content-disposition'] || '';
        const match = /filename="?([^"]+)"?/i.exec(dispo);
        const filename = match?.[1] || `${rfqCode}.csv`;

        const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        return { filename };
    },

    importPreview: async (rfqId, file) => {
        const form = new FormData();
        form.append('file', file);
        const { data } = await api.post(`/rfqs/${rfqId}/import`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return data.data;
    },

    importCommit: async (rfqId, file, meta = {}) => {
        const form = new FormData();
        form.append('file', file);
        if (meta.currency) form.append('currency', meta.currency);
        if (meta.validUntil) form.append('validUntil', meta.validUntil);
        if (meta.deliveryDays) form.append('deliveryDays', String(meta.deliveryDays));
        if (meta.paymentTerms) form.append('paymentTerms', meta.paymentTerms);
        if (meta.notes) form.append('notes', meta.notes);

        const { data } = await api.post(`/rfqs/${rfqId}/import?commit=true`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return data.data;
    },
};